import { IMessageType } from '../types';

import { RecurringTripReqMsg as IRecurringTripReqMsg } from '~/api/messages/IRecurringTripReqMsg';
import { IRecurringTripRespMsg } from '~/api/messages/IRecurringTripRespMsg';
import { IRecurringTripUpdateReqMsg } from '~/api/messages/IRecurringTripUpdateReqMsg';
import { IStatusMsg } from '~/api/messages/IStatusMsg';

export const RecurringTripUpdateReqMsg: IMessageType<IRecurringTripUpdateReqMsg, IStatusMsg > = {
  requestName: 'RecurringTripUpdateReqMsg',
  responseName: 'StatusMsg',
};

export const RecurringTripReqMsg: IMessageType<IRecurringTripReqMsg, IRecurringTripRespMsg> = {
  requestName: 'RecurringTripReqMsg',
  responseName: 'RecurringTripMsg',
};
